/**
 * Reverse IP Lookup Tool Entry Point
 */
import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import App from './App.vue';
import 'ant-design-vue/dist/reset.css';

// Find all reverse IP lookup containers and mount Vue app to each
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.cnfltd-reverse-ip-lookup-wrapper');
  
  containers.forEach((container) => {
    if (container instanceof HTMLElement) {
      const app = createApp(App);
      app.use(Antd);
      app.mount(container);
    }
  });
});
